import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="payment-cancel-page">
      <div className="mx-auto h-16 w-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-4">
        <XCircle className="h-10 w-10 text-amber-600" />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Paiement annulé</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 max-w-md">
        Aucun montant n'a été prélevé. Votre créneau est temporairement libéré.
        Vous pouvez réessayer depuis le profil de l'expert.
      </p>
      <button
        data-testid="payment-cancel-back-btn"
        onClick={() => navigate(-1)}
        className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white rounded-xl font-semibold"
      >
        <ArrowLeft className="h-4 w-4" /> Retour
      </button>
    </div>
  );
};

export default PaymentCancel;
